import { get, last } from 'lodash'
import { connect } from 'react-redux'
import actions from '../../actions/LevelFundedBenefitsSets'
import historyActions from '../../actions/BenefitsSetFieldHistories'
import BenefitsSetShow from '../BenefitsSet/BenefitsSetShow'
import LevelFundedBenefitsSetComponent from './LevelFundedBenefitsSetComponent'

const mapStateToProps = (state) => {
  const slice = state.levelFundedBenefitsSets.show

  const configuration = state.login.session.configuration.level_funded_benefits
  const historySlice = state.benefitsSetFieldHistory.index
  return {
    benefitsSet: slice.attributes,
    rejection: last(get(slice.attributes, 'rejections', [])),
    configuration,
    benefitsSetFieldHistory: historySlice.records,
    productLine: 'Level Funded',
    benefitsSetComponent: LevelFundedBenefitsSetComponent
  }
}

const mapDispatchToProps = {
  show: actions.show.main,
  reset: actions.show.reset,
  history: historyActions.index.main,
  resetHistory: historyActions.index.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(BenefitsSetShow)
